

    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Prop } from "vue-property-decorator";
    import { Watch } from "vue-property-decorator";
    import { ContractorDefaultScanTimes } from '@/model/ContractorDefaultScanTimes';

    @Component({
        components: {
            ApiButton
        }
    })

    export default class ReportSettingsTab extends Vue {

        //
        // -- properties
        //

        @Prop({}) private booking !: BookingVM;
        @Prop({}) private contractorDefaultScanTimes !: ContractorDefaultScanTimes;

        private exampleEarliestSignInTime = "22:00";
        private exampleLatestSignInTime = "22:00";
        private exampleEarliestSignOutTime = "08:00";
        private exampleLatestSignOutTime = "08:00";
        private exampleDefaultStayDuration = "0.0";
        private exampleTargetCheckOut = "00:00"
        private requiresSave = false;

        private timeOptions: Array<number> = [
            0, 0.5, 1, 1.5, 2, 2.5,
            3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5,
            8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12
        ];

        private get isDisabled() {
            if (this.booking.statusID === 3) { return true }
            if (this.booking.statusID === 4) { return true }
            if (this.booking.statusID === 5) { return true }
            if (this.booking.statusID === 6) { return true }
            else return false;
        }

        @Watch("booking.scanInEarliestDifference", { immediate: false, deep: true })
        onScanInEarliestDifferenceChanged(value: string) {
            this.$emit("setRequiresSave");
            return this.exampleEarliestSignInTime = this.convertTimeSubtract(this.booking.scanInEarliestDifference, "scanin");
        }

        @Watch("booking.scanInLatestDifference")
        onScanInLatestDifferenceChanged(value: string) {
            this.$emit("setRequiresSave");
            return this.exampleLatestSignInTime = this.convertTimeAdd(this.booking.scanInLatestDifference, "scanin");
        }

        @Watch("booking.scanOutEarliestDifference")
        onScanOutEarliestDifferenceChanged(value: string) {
            this.$emit("setRequiresSave");
            return this.exampleEarliestSignOutTime = this.convertTimeSubtract(this.booking.scanOutEarliestDifference, "scanout");
        }

        @Watch("booking.scanOutLatestDifference")
        onScanOutLatestDifferenceChanged(value: string) {
            this.$emit("setRequiresSave");
            return this.exampleLatestSignOutTime = this.convertTimeAdd(this.booking.scanOutLatestDifference, "scanout");
        }

        @Watch("booking.scanDefaultStayDuration")
        onScanDefaultStayDurationChanged(value: number) {
            this.$emit("setRequiresSave");
            this.exampleTargetCheckOut = this.convertTimeForTargetCheckOutString(this.booking.scanDefaultStayDuration);//sets the example target checkout string
            this.exampleDefaultStayDuration = this.booking.scanDefaultStayDuration.toString();//sets the duration string
            this.exampleEarliestSignOutTime = this.convertTimeForEarliestCheckOutString(this.booking.scanDefaultStayDuration);//sets the earliest sign in time
            this.exampleLatestSignOutTime = this.convertTimeForLatestCheckOutString(this.booking.scanDefaultStayDuration);//sets the latest sign in time
        }

        mounted() {
            this.exampleEarliestSignInTime = this.convertTimeSubtract(this.booking.scanInEarliestDifference, "scanin");
            this.exampleLatestSignInTime = this.convertTimeAdd(this.booking.scanInLatestDifference, "scanin");
            this.exampleEarliestSignOutTime = this.convertTimeSubtract(this.booking.scanOutEarliestDifference, "scanout");
            this.exampleLatestSignOutTime = this.convertTimeAdd(this.booking.scanOutLatestDifference, "scanout");
            this.exampleTargetCheckOut = this.convertTimeForTargetCheckOutString(this.booking.scanDefaultStayDuration);//sets the example target checkout string
            this.exampleDefaultStayDuration = this.booking.scanDefaultStayDuration.toString();//sets the duration string
        }

        convertTimeSubtract(timeToSubTract: number, origin: string) {
            let n = new Date();
            if (origin === "scanin") n = new Date(0, 0, 0, 22, 0, 0);
            if (origin === "scanout") {
                const x = this.convertTimeForTargetCheckOutString(this.booking.scanDefaultStayDuration)
                const minutes = +x.slice(3);
                const hours = +x.slice(0, 2)
                n = new Date(0, 0, 0, hours, minutes, 0);
            }
            n.setSeconds(-timeToSubTract * 60 * 60);

            return n.toTimeString().slice(0, 5);
        }

        convertTimeAdd(timeToAdd: number, origin: string) {
            let n = new Date();
            if (origin === "scanin") n = new Date(0, 0, 0, 22, 0, 0);
            if (origin === "scanout") {
                const x = this.convertTimeForLatestCheckOutString(this.booking.scanDefaultStayDuration)
                const minutes = +x.slice(3);
                const hours = +x.slice(0, 2)
                n = new Date(0, 0, 0, hours, minutes, 0);
            }
            n.setSeconds(+timeToAdd * 60 * 60);
            return n.toTimeString().slice(0, 5);
        }

        convertTimeForTargetCheckOutString(timeToAdd: number) {
            let n = new Date();
            n = new Date(0, 0, 0, 22, 0, 0);
            n.setSeconds(+timeToAdd * 60 * 60);
            return n.toTimeString().slice(0, 5);
        }

        convertTimeForEarliestCheckOutString(timeToAdd: number) {
            let n = new Date();
            n = new Date(0, 0, 0, 22, 0, 0);
            n.setSeconds((+timeToAdd * 60 * 60) - this.booking.scanOutEarliestDifference);
            const ms = 1000 * 60 * 1;
            const roundedTime = new Date(Math.round(n.getTime() / ms) * ms);//make sure time is rounded to the nearest minute, otherwise we lose 3 seconds..
            return roundedTime.toTimeString().slice(0, 5);
        }

        convertTimeForLatestCheckOutString(timeToAdd: number) {
            let n = new Date();
            n = new Date(0, 0, 0, 22, 0, 0);
            n.setSeconds(+timeToAdd * 60 * 60);
            n.setSeconds(+this.booking.scanOutLatestDifference)
            return n.toTimeString().slice(0, 5);
        }

        async useContractorDefaults() {
            this.booking.scanDefaultStayDuration = this.contractorDefaultScanTimes.scanDefaultStayDuration;
            this.booking.scanInEarliestDifference = this.contractorDefaultScanTimes.scanInEarliestDifference;
            this.booking.scanInLatestDifference = this.contractorDefaultScanTimes.scanInLatestDifference;
            this.booking.scanOutEarliestDifference = this.contractorDefaultScanTimes.scanOutEarliestDifference;
            this.booking.scanOutLatestDifference = this.contractorDefaultScanTimes.scanOutLatestDifference;
            this.$emit("setRequiresSave");
        }

    }
